import "./SurveyDetailsComponent.scss";

import { TeamsApplicationTypes } from "@teams/types";
import React from "react";

import { ReactComponent as AgileSurveyImage } from "../../../../_shared/assets/agile-survey-image.svg";
import { ReactComponent as CoreSurveyImage } from "../../../../_shared/assets/core-survey-image.svg";
import { HeroUnit, coreHeroUnitStyles } from "../../../../_shared/components/HeroUnit";

interface SurveyDetailsComponentProps {
  applicationType: TeamsApplicationTypes;
}
export const SurveyDetailsComponent: React.FC<SurveyDetailsComponentProps> = ({
  applicationType,
}) => {
  return (
    <div className="surveyDetails">
      <HeroUnit style={{ ...coreHeroUnitStyles, alignItems: "center" }}>
        {applicationType === "msteams" ? <CoreSurveyImage /> : <AgileSurveyImage />}
      </HeroUnit>
    </div>
  );
};
